import { MiscellaneousField } from '../../reportsTypes';
import {
  FieldEnabledState,
  MiscellaneousStringItem,
} from './MiscellaneousStringItem';
import { UseFormReturn, FieldValues } from 'react-hook-form';
import { MiscellaneousBooleanItem } from './MiscellaneousBooleanItem';
import { MiscellaneousDayTimeDurationItem } from './MiscellaneousDayTimeDurationItem';
import React from 'react';
import { MiscellaneousTimeDurationItem } from './MiscellaneousTimeDurationItem';
import { MiscellaneousSelectItem } from './MiscellaneousSelectItem';
import { MiscellaneousMultiSelectItem } from './MiscellaneousMultiSelectItem';
import { MiscellaneousNumberItem } from './MiscellaneousNumberItem';
import { MiscellaneousColorIntervalItem } from './MiscellaneousColorIntervalItem';
import { MiscellaneousVideoSegmentsItem } from './MiscellaneousVideoSegments';
import { DateRange } from 'react-day-picker';
import { MiscellaneousTextItem } from './MiscellaneousTextItem';

interface FieldRendererProps<T extends FieldValues = FieldValues> {
  fieldName: string;
  fieldInfo: MiscellaneousField;
  fieldEnabledState: FieldEnabledState;
  form: UseFormReturn<T>;
  prefix: boolean;
  dateRange: DateRange | undefined;
}

export const MiscellaneousFieldRenderer = <T extends FieldValues = FieldValues>({
  fieldName,
  fieldInfo,
  fieldEnabledState,
  form,
  prefix,
  dateRange,
}: FieldRendererProps<T>) => {
  if (!fieldEnabledState[fieldName]) {
    return null;
  }

  const formName = prefix ? `miscellaneous.${fieldName}` : fieldName;

  switch (fieldInfo.fieldType) {
    case 'string':
      return (
        <MiscellaneousStringItem
          key={fieldName}
          fieldName={formName}
          fieldInfo={fieldInfo}
          form={form as UseFormReturn<FieldValues>}
        />
      );
    case 'text':
      return (
        <MiscellaneousTextItem
          key={fieldName}
          fieldName={formName}
          fieldInfo={fieldInfo}
          form={form as UseFormReturn<FieldValues>}
        ></MiscellaneousTextItem>
      );
    case 'boolean':
      return (
        <MiscellaneousBooleanItem
          key={fieldName}
          fieldName={formName}
          fieldInfo={fieldInfo}
          form={form as UseFormReturn<FieldValues>}
        />
      );
    case 'dayTimeDuration':
      return (
        <MiscellaneousDayTimeDurationItem
          key={fieldName}
          fieldName={formName}
          fieldInfo={fieldInfo}
          form={form as UseFormReturn<FieldValues>}
        />
      );

    case 'timeDuration':
      return (
        <MiscellaneousTimeDurationItem
          key={fieldName}
          fieldName={formName}
          fieldInfo={fieldInfo}
          form={form as UseFormReturn<FieldValues>}
        />
      );

    case 'select':
      return (
        <MiscellaneousSelectItem
          key={fieldName}
          fieldName={formName}
          fieldInfo={fieldInfo}
          form={form as UseFormReturn<FieldValues>}
        />
      );
    case 'multiSelect':
      return (
        <MiscellaneousMultiSelectItem
          key={fieldName}
          fieldName={formName}
          fieldInfo={fieldInfo}
          form={form as UseFormReturn<FieldValues>}
        />
      );
    case 'number':
      return (
        <MiscellaneousNumberItem
          key={fieldName}
          fieldName={formName}
          fieldInfo={fieldInfo}
          form={form as UseFormReturn<FieldValues>}
        />
      );
    case 'colorInterval':
      return (
        <MiscellaneousColorIntervalItem
          key={fieldName}
          fieldName={formName}
          fieldInfo={fieldInfo}
          form={form as UseFormReturn<FieldValues>}
        />
      );
    case 'videoSegments':
      return (
        <MiscellaneousVideoSegmentsItem
          key={fieldName}
          fieldName={formName}
          fieldInfo={fieldInfo}
          form={form as UseFormReturn<FieldValues>}
          dateRange={dateRange}
        />
      );
    default:
      return null;
  }
};
